import type { NoteDetail, NoteFormatChoice } from '@/types/noteStyle';

/** Detail levels run left to right. */
export const NOTE_DETAIL_LEVELS: NoteDetail[] = ['short', 'balanced', 'detailed'];

/** The format choice that saves no format, so the template decides the layout. */
export const TEMPLATE_FORMAT = 'template';

export const NOTE_FORMAT_CHOICES: NoteFormatChoice[] = [TEMPLATE_FORMAT, 'prose', 'bullets'];

export const NOTE_DETAIL_LABELS: Record<NoteDetail, string> = {
  short: 'Hnitmiðað',
  balanced: 'Miðlungs',
  detailed: 'Ítarlegt',
};

export const NOTE_FORMAT_LABELS: Record<NoteFormatChoice, string> = {
  template: 'Eftir sniðmáti',
  prose: 'Samfelldur texti',
  bullets: 'Punktar',
};
